import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as n, jsxs as K } from "react/jsx-runtime";
import { useId as q, useRef as x } from "react";
import { useModal as G } from "@ebay/nice-modal-react";
import { useFloating as J, useInteractions as L, useClick as Q, useRole as U, useDismiss as V, FloatingOverlay as X, FloatingFocusManager as Y } from "@floating-ui/react";
import m from "classnames";
import { Transition as Z } from "react-transition-group";
import _ from "../FloatingTreeWrapper/FloatingTreeWrapper.js";
import w from "../../assets/icons/close-modal.svg.js";
import a from "./Modal.module.scss.js";
function P(e) {
  return e instanceof String || typeof e == "string";
}
var p = {
    xs: 300,
    sm: 500,
    md: 700,
    lg: 900,
    xl: 1200
  },
  s = 300,
  ee = "calc(100vw - 32px)",
  ne = "90vh",
  C = {
    transition: "opacity ".concat(s, "ms cubic-bezier(0.8, 0.5, 0.2, 1.2), background ").concat(s, "ms cubic-bezier(0.8, 0.5, 0.2, 1.2), transform ").concat(s, "ms cubic-bezier(0.8, 0.5, 0.2, 1.2)")
  },
  te = {
    unmounted: {
      opacity: 1,
      background: "rgba(65, 69, 98, 0.9)"
    },
    entering: {
      opacity: 1,
      background: "rgba(65, 69, 98, 0.9)"
    },
    entered: {
      opacity: 1,
      background: "rgba(65, 69, 98, 0.9)"
    },
    exiting: {
      opacity: 0,
      background: "rgba(65, 69, 98, 0.9)"
    },
    exited: {
      opacity: 0,
      background: "rgba(65, 69, 98, 0.9)",
      zIndex: -1
    }
  },
  M = function M(_ref) {
    var _p$e;
    var _ref$width = _ref.width,
      e = _ref$width === void 0 ? "md" : _ref$width,
      o = _ref.children,
      _ref$closable = _ref.closable,
      r = _ref$closable === void 0 ? !1 : _ref$closable,
      c = _ref.afterClose,
      t = _ref.closeButton,
      _ref$maxWidth = _ref.maxWidth,
      f = _ref$maxWidth === void 0 ? ee : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      h = _ref$maxHeight === void 0 ? ne : _ref$maxHeight,
      k = _ref.fullWidth,
      _ref$lockScroll = _ref.lockScroll,
      v = _ref$lockScroll === void 0 ? !0 : _ref$lockScroll,
      F = _ref.portalId,
      I = _ref.root,
      S = _ref.isAbsolute,
      z = _ref.className,
      N = _ref.closeButtonStyles,
      g = _ref.onClose,
      $ = _ref.keepMounted,
      b = _ref.open,
      _ref$enableEscapeKeyT = _ref.enableEscapeKeyToDismiss,
      E = _ref$enableEscapeKeyT === void 0 ? !0 : _ref$enableEscapeKeyT,
      _ref$enableOutsidePre = _ref.enableOutsidePressToDismiss,
      O = _ref$enableOutsidePre === void 0 ? !0 : _ref$enableOutsidePre,
      d = _ref.slotProps;
    var u = q(),
      y = x(null),
      R = x(null),
      _J = J({
        open: b,
        onOpenChange: function onOpenChange(i) {
          i === !1 && g();
        }
      }),
      T = _J.refs,
      l = _J.context,
      _L = L([Q(l), U(l), V(l, {
        enabled: r,
        escapeKey: E,
        outsidePress: O
      })]),
      W = _L.getFloatingProps,
      j = P(e) ? (_p$e = p[e]) !== null && _p$e !== void 0 ? _p$e : e : e,
      A = "".concat(u, "-label"),
      B = "".concat(u, "-description"),
      D = t !== null ? /* @__PURE__ */n("button", _objectSpread(_objectSpread({
        type: "button",
        className: m(a.closeModalButton, N),
        onClick: function onClick() {
          return g();
        },
        "data-cy": "close-modal-button"
      }, d == null ? void 0 : d.closeTrigger), {}, {
        children: t !== null && t !== void 0 ? t : /* @__PURE__ */n(w, {})
      })) : null;
    return /* @__PURE__ */n(_, {
      portalId: F,
      root: I,
      children: /* @__PURE__ */n(Z, {
        ref: R,
        nodeRef: y,
        in: b,
        timeout: s,
        unmountOnExit: !$,
        mountOnEnter: !0,
        appear: !0,
        onExited: c,
        children: function children(i) {
          var H = i === "exited";
          return /* @__PURE__ */n(X, {
            id: u,
            style: _objectSpread(_objectSpread({}, C), te[i]),
            ref: y,
            className: m(a.modalWrapper, _defineProperty({}, a.modalAbsolute, S)),
            lockScroll: H ? !1 : v,
            children: /* @__PURE__ */n(Y, {
              context: l,
              children: /* @__PURE__ */K("div", _objectSpread(_objectSpread({
                className: m(a.modalContentContainer, a[i], "mashModalContainer", z),
                style: _objectSpread(_objectSpread({
                  width: k ? f : j
                }, C), {}, {
                  maxWidth: f,
                  maxHeight: h
                }),
                ref: T.setFloating,
                "aria-labelledby": A,
                "aria-describedby": B
              }, W()), {}, {
                children: [r ? D : null, o]
              }))
            })
          });
        }
      })
    });
  },
  oe = function oe(e) {
    var o = G(),
      r = function r() {
        var t;
        o.hide(), (t = e.onClose) == null || t.call(e);
      },
      c = function c() {
        var t;
        (t = e.afterClose) == null || t.call(e), e.keepMounted || o.remove();
      };
    return /* @__PURE__ */n(M, _objectSpread(_objectSpread({}, e), {}, {
      open: o.visible,
      onClose: r,
      afterClose: c
    }));
  },
  fe = function fe(e) {
    return e.open !== void 0 && e.onClose !== void 0 ? /* @__PURE__ */n(M, _objectSpread(_objectSpread({}, e), {}, {
      open: e.open,
      onClose: e.onClose
    })) : /* @__PURE__ */n(oe, _objectSpread({}, e));
  };
export { fe as default };